import { render, staticRenderFns } from "./EventPartners.vue?vue&type=template&id=525a6c1b&scoped=true"
import script from "./EventPartners.vue?vue&type=script&lang=js"
export * from "./EventPartners.vue?vue&type=script&lang=js"
import style0 from "./EventPartners.vue?vue&type=style&index=0&id=525a6c1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525a6c1b",
  null
  
)

export default component.exports